export default __webpack_public_path__ + "static/media/s77auimage_33.c3be2521.png";